import client from "../Client/HttpClient";
import { ISaberTypesModel } from "@/interfaces/modules";

const ApiPath = "SaberTypes";

export default {
  GetSaberTypes: (): Promise<ISaberTypesModel[]> => client.get(`${ApiPath}`),
  GetSaberTypesById: (data: ISaberTypesModel): Promise<ISaberTypesModel> =>
    client.get(`${ApiPath}/${data.Id}`),
  PostSaberTypes: (data: ISaberTypesModel): Promise<ISaberTypesModel> =>
    client.post(`${ApiPath}`, data),
};
